/* Selborne OS2 1.0 — production Shopify interactions. No preview cart adapter here. */
(() => {
  'use strict';
  if (window.SCStore) return;
  const state = window.SCStore = {busy:false};
  const root = () => window.Shopify?.routes?.root || '/';
  const $ = (s, el=document) => el.querySelector(s);
  const $$ = (s, el=document) => [...el.querySelectorAll(s)];
  const revealObserver = 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches ? new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('sc-reveal');revealObserver.unobserve(entry.target);}});
  },{threshold:0.08}) : null;
  const observed = new WeakSet();
  const catalogDisposals = new WeakMap();
  const navMedia=matchMedia('(min-width:901px)');
  navMedia.addEventListener?.('change',()=>$$('[data-sc-menu]').forEach(menu=>{menu.open=navMedia.matches;}));
  let toastTimer, cartRead=0;
  function toast(message, cartLink=false) {
    const el=$('[data-sc-toast]'); if(!el) return;
    el.replaceChildren(document.createTextNode(message));
    if(cartLink){const a=document.createElement('a');a.href=root()+'cart';a.textContent='View cart';el.append(a);}
    el.hidden=false; clearTimeout(toastTimer); toastTimer=setTimeout(()=>el.hidden=true,9000);
  }
  const wasDisabled = new Map();
  function lock(on){
    state.busy=on;
    if(on)cartRead++; // Invalidate any earlier read that could overwrite a newer mutation.
    if(on){
      $$('[data-sc-add] button, [data-sc-line-form] button, [data-sc-line-form] input, [data-sc-checkout] button').forEach(el=>{wasDisabled.set(el,el.disabled);el.disabled=true;});
      $('[data-sc-cart]')?.setAttribute('aria-busy','true');
    }else{
      wasDisabled.forEach((disabled,el)=>{if(el.isConnected)el.disabled=disabled;});wasDisabled.clear();
      $('[data-sc-cart]')?.removeAttribute('aria-busy');
      $$('[data-sc-product]').forEach(updateVariant);
    }
  }
  async function request(url, options={}) {
    const controller = new AbortController();
    const timer=setTimeout(()=>controller.abort(),20000);
    try {
      const response=await fetch(url,{credentials:'same-origin',...options,signal:controller.signal});
      const data=await response.json();
      if(!response.ok){const e=new Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:'Shopify could not complete this change. Review your cart and try again.');e.confirmedError=true;throw e;}
      return data;
    } finally {clearTimeout(timer);}
  }
  function countCart(cart){
    if(Number.isFinite(cart?.item_count)) $$('[data-sc-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
  }
  async function refreshCount(){const ticket=++cartRead;const cart=await request(root()+'cart.js');if(ticket===cartRead)countCart(cart);return cart;}
  function replaceCart(html, focusIndex=null){
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=$('[data-sc-cart]',doc), old=$('[data-sc-cart]');
    if(!fresh||!old)throw new Error('The cart view could not be refreshed.');
    old.replaceWith(fresh);
    if(focusIndex!==null){const fields=$$('input[name="quantity"][type="number"]',fresh);(fields[Math.min(focusIndex,fields.length-1)]||$('h1',fresh))?.focus();}
  }
  async function refreshCartView(sectionId){
    const response=await fetch(root()+'cart?section_id='+encodeURIComponent(sectionId),{credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error('The cart view could not be refreshed.');
    replaceCart(await response.text());
  }
  async function add(form){
    if(state.busy)return;
    const fd=new FormData(form), status=$('[data-sc-add-status]',form);
    if(status)status.textContent='Adding…';
    lock(true);
    try{
      await request(root()+'cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      // The add is never repeated, including when this follow-up read fails.
      await refreshCount();
      if(status)status.textContent='Added to your cart.';
      toast('Added to your cart.',true);
    }catch(error){
      refreshCount().catch(()=>{});
      const message=error.confirmedError?error.message:'We could not confirm the result. Check your cart before trying to add this item again.';
      if(status)status.textContent=message;
      toast(message,true);
    }finally{lock(false);}
  }
  async function change(form){
    if(state.busy)return;
    const cartEl=form.closest('[data-sc-cart]');if(!cartEl)return;
    const data=new FormData(form), quantity=Number(data.get('quantity'));
    if(!Number.isSafeInteger(quantity)||quantity<0){toast('Enter a whole quantity of zero or more.');return;}
    const sectionId=cartEl.dataset.sectionId;
    const lineIndex=$$('[data-sc-line]',cartEl).indexOf(form.closest('[data-sc-line]'));
    const payload={id:String(data.get('id')),quantity,sections:[sectionId],sections_url:root()+'cart'};
    const status=$('[data-sc-cart-status]',cartEl);if(status)status.textContent='Updating your cart…';
    lock(true);
    try{
      const cart=await request(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      countCart(cart);
      if(cart.sections?.[sectionId])replaceCart(cart.sections[sectionId],lineIndex);
      else await refreshCartView(sectionId);
      const current=$('[data-sc-cart-status]');if(current)current.textContent='Your cart has been updated.';
    }catch(error){
      // Read-only reconciliation after errors. Never replay a mutation.
      try{await refreshCartView(sectionId);await refreshCount();}catch(_){/* Native reload link remains available. */}
      const current=$('[data-sc-cart-status]');
      const message=error.confirmedError?error.message:'We could not confirm the update. Review the cart before changing it again.';
      if(current)current.textContent=message;toast(message,true);
    }finally{lock(false);}
  }
  function updateVariant(productEl){
    const select=$('[data-sc-variant]',productEl),option=select?.selectedOptions[0];if(!option)return;
    const price=$('[data-sc-price]',productEl),button=$('[data-sc-product-add]',productEl);
    if(price)price.textContent=option.dataset.price;
    if(button){button.disabled=state.busy||option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?'Add to cart':'Unavailable';}
    const image=$('[data-sc-main-image]',productEl);
    if(image&&option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');image.alt=option.dataset.imageAlt||image.alt;}
  }
  async function initCatalog(el){
    if(el.dataset.scReady)return;el.dataset.scReady='loading';
    const status=$('[data-sc-catalog-status]',el),grid=$('[data-sc-products]',el);if(!grid)return;
    const map=new Map();$$('[data-sc-card]',el).forEach(card=>map.set(card.dataset.handle,card));
    let ready=false,cards=[],visited=new Set();
    const validCategories={all:null,desks:'sc-desks',seating:'sc-seating',accessories:'sc-accessories'};
    const validSort=['featured','price-ascending','price-descending','title-ascending','created-descending'];
    function apply(){
      if(!ready)return;
      const query=new URL(location.href).searchParams;
      const wanted=query.get('category')||'all';const category=Object.hasOwn(validCategories,wanted)?wanted:'all';
      const wantedSort=query.get('sort_by')||'featured', sort=validSort.includes(wantedSort)?wantedSort:'featured';
      const ordered=cards.slice();
      if(sort==='price-ascending')ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
      if(sort==='price-descending')ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
      if(sort==='title-ascending')ordered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title,'en'));
      if(sort==='created-descending')ordered.sort((a,b)=>Number(b.dataset.created)-Number(a.dataset.created));
      let total=0;
      ordered.forEach(card=>{card.hidden=!!validCategories[category]&&!card.dataset.tags.split(',').includes(validCategories[category]);if(!card.hidden)total++;grid.append(card);});
      $$('[data-sc-filter]',el).forEach(a=>a.setAttribute('aria-current',String(a.dataset.scFilter===category)));
      $('[data-sc-sort]',el).value=sort;
      $('[data-sc-no-results]',el).hidden=total!==0;
      status.textContent=total+' '+(total===1?'product':'products')+(category!=='all'?' in this category':'');
    }
    function navigate(category,sort){
      const url=new URL(location.href);url.searchParams.delete('page');
      if(category==='all')url.searchParams.delete('category');else if(category)url.searchParams.set('category',category);
      if(sort==='featured')url.searchParams.delete('sort_by');else if(sort)url.searchParams.set('sort_by',sort);
      history.pushState({},'',url);apply();
    }
    el.addEventListener('click',e=>{const a=e.target.closest('[data-sc-filter]');if(!a||!ready||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();navigate(a.dataset.scFilter,null);});
    $('[data-sc-sort]',el)?.addEventListener('change',e=>{if(ready)navigate(null,e.target.value);});
    window.addEventListener('popstate',apply);
    catalogDisposals.set(el,()=>window.removeEventListener('popstate',apply));
    try{
      status.textContent='Loading the complete catalog…';
      let next=$('[data-sc-next]',el)?.href;
      // A direct paginated link must still include products from earlier pages.
      if(new URL(location.href).searchParams.has('page')){const first=new URL(location.href);first.searchParams.delete('page');next=first.href;map.clear();}
      while(next){
        const url=new URL(next,location.href);if(url.origin!==location.origin||visited.has(url.href)||visited.size>1050)throw new Error('Catalog pagination is incomplete.');
        visited.add(url.href);
        const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Catalog request failed.');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const incoming=$('[data-sc-catalog]',doc);if(!incoming)throw new Error('Catalog data unavailable.');
        $$('[data-sc-card]',incoming).forEach(card=>{if(!map.has(card.dataset.handle))map.set(card.dataset.handle,card);});
        const n=$('[data-sc-next]',incoming);next=n?new URL(n.getAttribute('href'),url).href:null;
      }
      cards=[...map.values()];ready=true;el.dataset.scReady='true';
      $$('[data-sc-pagination],[data-sc-next]',el).forEach(n=>n.hidden=true);apply();
    }catch(_){
      el.dataset.scReady='error';status.textContent='We could not load the complete catalog. Browse all products using the page links below, or refresh to try filtering again.';
      $('[data-sc-sort]',el).disabled=true;
    }
  }
  function init(context=document){
    $$('[data-sc-menu]',context).forEach(el=>{if(el.dataset.scInit)return;el.dataset.scInit='true';el.open=matchMedia('(min-width:901px)').matches;const summary=$('summary',el);summary?.setAttribute('aria-expanded',String(el.open));el.addEventListener('toggle',()=>summary?.setAttribute('aria-expanded',String(el.open)));});
    $$('[data-sc-product]',context).forEach(updateVariant);
    $$('[data-sc-catalog]',context).forEach(initCatalog);
    if(revealObserver)$$('.sc-section,.sc-card,.sc-split',context).forEach(el=>{if(!observed.has(el)){observed.add(el);revealObserver.observe(el);}});
    const success=$('.sc-form-success',context);if(success)success.focus();
  }
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(form.matches('[data-sc-contact]')){
      $$('input,textarea',form).forEach(input=>{if(['hidden','submit'].includes(input.type))return;input.value=input.value.trim();input.setCustomValidity(input.required&&!input.value?'Please complete this field.':'');});
      const phone=$('input[type=tel]',form);if(phone?.value&&phone.value.replace(/\D/g,'').length<7)phone.setCustomValidity('Please enter a valid phone number.');
      if(!form.reportValidity())e.preventDefault();return;
    }
    if(form.matches('[data-sc-checkout]')){if(state.busy)e.preventDefault();return;}
    if(!window.fetch)return;
    if(form.matches('[data-sc-add],[data-sc-line-form]')){
      e.preventDefault();if(!form.reportValidity())return;
      form.matches('[data-sc-add]')?add(form):change(form);
    }
  });
  document.addEventListener('input',e=>{if(e.target.closest('[data-sc-contact]'))e.target.setCustomValidity?.('');});
  document.addEventListener('change',e=>{
    if(e.target.matches('[data-sc-variant]')){const product=e.target.closest('[data-sc-product]');updateVariant(product);const url=new URL(location.href);url.searchParams.set('variant',e.target.value);history.replaceState({},'',url);}
    if(e.target.matches('[data-sc-line-form] input[type=number]')&&!state.busy)e.target.form.requestSubmit();
  });
  document.addEventListener('click',e=>{
    const step=e.target.closest('[data-sc-step]');
    if(step){e.preventDefault();if(state.busy)return;const input=$('input[name=quantity]',step.form);input.value=String(Math.max(0,(Number(input.value)||0)+Number(step.dataset.scStep)));step.form.requestSubmit();return;}
    const thumb=e.target.closest('[data-sc-thumb]');
    if(thumb){e.preventDefault();const image=$('[data-sc-main-image]',thumb.closest('[data-sc-gallery]')||thumb.closest('[data-sc-product]'));if(image){image.src=thumb.href;image.removeAttribute('srcset');image.alt=$('img',thumb)?.alt||image.alt;}return;}
    if(e.target.closest('.sc-nav a')&&matchMedia('(max-width:900px)').matches){const menu=e.target.closest('[data-sc-menu]');if(menu)menu.open=false;}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')$$('[data-sc-menu][open]').forEach(menu=>{menu.open=false;$('summary',menu)?.focus();});});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    $$('[data-sc-catalog]',e.target).forEach(el=>{catalogDisposals.get(el)?.();catalogDisposals.delete(el);});
    if(revealObserver)$$('.sc-section,.sc-card,.sc-split',e.target).forEach(el=>revealObserver.unobserve(el));
  });
  document.addEventListener('DOMContentLoaded',()=>init());
  window.addEventListener('pageshow',()=>refreshCount().catch(()=>{}));
  if(document.readyState!=='loading')init();
})();
